export const eventTypes = {
  WIDGET_SHOWN: 'WIDGET_SHOWN',
  PLAIN_MESSAGE_SHOWN: 'PLAIN_MESSAGE_SHOWN',
  WIDGET_NOT_SHOWN: 'WIDGET_NOT_SHOWN',
  ATTACH_FILES: 'ATTACH_FILES',
  GREETING_MESSAGE_SHOWN: 'GREETING_MESSAGE_SHOWN',
  GREETING_MESSAGE_CLICKED: 'GREETING_MESSAGE_CLICKED',
  GREETING_MESSAGE_BUTTONS_SHOWN :'GREETING_MESSAGE_BUTTONS_SHOWN',
  GREETING_MESSAGE_BUTTON_CLICKED:'GREETING_MESSAGE_BUTTON_CLICKED',
  GIF_SHOWN: 'GIF_SHOWN',
  GIF_SENT: 'GIF_SENT',
  GIF_IN_GREETING_MESSAGE_SHOWN: 'GIF_IN_GREETING_MESSAGE_SHOWN',
  GIF_IN_GREETING_MESSAGE_CLICKED: 'GIF_IN_GREETING_MESSAGE_CLICKED ',
  WIDGET_ICON_CLICKED: 'WIDGET_ICON_CLICKED',
  TRIGGER_BOT_CLICKED: 'TRIGGER_BOT_CLICKED',
  CONVERSATION_PAGE_LOADED: 'CONVERSATION_PAGE_LOADED',
  HOME_PAGE_LOADED: 'HOME_PAGE_LOADED',
  GREETING_MESSAGE_CLOSED: 'GREETING_MESSAGE_CLOSED',
  CONVERSATION_PAGE_CLOSED: 'CONVERSATION_PAGE_CLOSED',
  HOME_PAGE_CLOSED: 'HOME_PAGE_CLOSED',
  AGENT_CONNECTED: 'AGENT_CONNECTED',
  AGENT_CONNECTED_CLICKED: 'AGENT_CONNECTED_CLICKED',
  AGENT_CONNECTED_CLOSED: 'AGENT_CONNECTED_CLOSED',
  PLAIN_INPUT_SHOWN: 'PLAIN_INPUT_SHOWN',
  PLAIN_INPUT_PROVIDED: 'PLAIN_INPUT_PROVIDED',
  USER_DATA_FIELD_SHOWN: 'USER_DATA_FIELD_SHOWN',
  USER_DATA_PROVIDED: 'USER_DATA_PROVIDED',
  BUTTONS_SHOWN: 'BUTTONS_SHOWN',
  BUTTON_CLICKED: 'BUTTON_CLICKED',
  CALENDAR_LINK_SHOWN: 'CALENDAR_LINK_SHOWN',
  CALENDAR_LINK_CLICKED: 'CALENDAR_LINK_CLICKED',
  PAGE_VISIT: 'PAGE_VISIT',
  ZENDESK_CREATE_TICKET_INPUT_SHOWN: 'ZENDESK_CREATE_TICKET_INPUT_SHOWN',
  ZENDESK_SEARCH_KNOWLEDGEBASE_INPUT_SHOWN: 'ZENDESK_SEARCH_KNOWLEDGEBASE_INPUT_SHOWN',
  ZENDESK_CREATE_TICKET_INPUT_PROVIDED: 'ZENDESK_CREATE_TICKET_INPUT_PROVIDED',
  ZENDESK_SEARCH_KNOWLEDGEBASE_INPUT_PROVIDED: 'ZENDESK_SEARCH_KNOWLEDGEBASE_INPUT_PROVIDED',
  SERVICE_CLOUD_CREATE_TICKET_INPUT_SHOWN: 'SERVICE_CLOUD_CREATE_TICKET_INPUT_SHOWN',
  SERVICE_CLOUD_SEARCH_KNOWLEDGEBASE_INPUT_SHOWN: 'SERVICE_CLOUD_SEARCH_KNOWLEDGEBASE_INPUT_SHOWN',
  SERVICE_CLOUD_CREATE_TICKET_INPUT_PROVIDED: 'SERVICE_CLOUD_CREATE_TICKET_INPUT_PROVIDED',
  SERVICE_CLOUD_SEARCH_KNOWLEDGEBASE_INPUT_PROVIDED: 'SERVICE_CLOUD_SEARCH_KNOWLEDGEBASE_INPUT_PROVIDED',
  DEBUG: 'DEBUG_CUSTOM_CUSTOMER_1',
  PAGE_FOCUS: 'DEBUG_PAGE_FOCUS',
  PAGE_BLUR: 'DEBUG_PAGE_BLUR',
  NATIVE_CALENDAR_SHOWN: 'NATIVE_CALENDAR_SHOWN',
  NATIVE_CALENDAR_CLOSED: 'NATIVE_CALENDAR_CLOSED',
  NATIVE_CALENDAR_NEXT_DATES_CLICKED: 'NATIVE_CALENDAR_NEXT_DATES_CLICKED',
  NATIVE_CALENDAR_NEXT_TIMES_CLICKED: 'NATIVE_CALENDAR_NEXT_TIMES_CLICKED'
};
